import * as React from 'react';
import { createComponent } from '@lit/react';

import { CodeEditorWC } from './code-editor.wc';
import {
  GenerateComponentTypeWithChildren,
  GeneratePropsWithRef,
} from '../../component-types-generics';

type CodeEditorEventProps = Pick<
  React.DOMAttributes<CodeEditorWC>,
  'onBlur' | 'onFocus'
>;

export type CodeEditorProps = GenerateComponentTypeWithChildren<CodeEditorWC> &
  CodeEditorEventProps;

export type CodeEditorPropsWithRef = GeneratePropsWithRef<CodeEditorProps>;

export const CodeEditor = createComponent({
  tagName: CodeEditorWC.tagname,
  elementClass: CodeEditorWC,
  react: React,
  events: {
    onBlur: 'blur',
    onFocus: 'focus',
  },
}) as CodeEditorPropsWithRef;
